export class RatingStudent {
  url: string;
  id: number;
  start: Date;
  status: string;
  message: string;
  level_grammar: string;
  grammar: number;
  level_accent: string;
  accent: number;
  level_expression: string;
  expression: number;
  level_comprehension: string;
  comprehension: number;
  level_vocabulary: string;
  vocabulary: number;
  session: string
  level_oral: string;
  level_written: string;
  constructor() { }
}